<template>
  <div
    class="bb-sidebar-email"
    :class="[isActiveEmail && 'bb-sidebar-email_active']"
    @click="goToRoute()"
  >
    <div class="bb-sidebar-email__icon">
      <i class="icon-ad"></i>
    </div>
    <transition name="fade">
      <span v-if="sidebarOpen" class="bb-sidebar-email__title">E-mail</span>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'EmailLink',
  props: {
    sidebarOpen: {
      type: Boolean,
      default: false
    },
    isActiveEmail: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      haveMessage: true
    }
  },
  methods: {
    goToRoute () {
      this.$emit('goToRouteEmail')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/transition";

  .bb-sidebar-email {
    display: flex;
    align-items: center;
    min-width: 81px;
    margin: 0 20px 22px 20px;
    cursor: pointer;
    position: relative;

    &:after {
      position: absolute;
      top: 20px;
      left: 20px;
      content: "";
      width: 0;
      height: 0;
      border-radius: 10px;
      transition: all 150ms;
    }

    &:hover:after {
      top: 0;
      left: 0;
      width: 41px;
      height: 41px;
      background-color: $color-accent-hover;
    }

    &_active {
      &:after {
        top: 0;
        left: 0;
        border-radius: 10px 0 0 10px;
        width: calc(100% + 20px) !important;
        height: calc(100%) !important;
        background-color: $color-accent-hover;
        transition: all 200ms;
      }
    }

    &__icon {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 41px;
      width: 41px;
      height: 41px;

      i {
        text-align: center;
        color: $color-white;
        z-index: 1;
      }
    }

    &__title {
      margin-left: 15px;
      font-size: 15px;
      line-height: 17px;
      color: $color-white;
      white-space: nowrap;
      z-index: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/EmailLink/EmailLink.vue